"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.sendEmail = void 0;
var Stateful = __importStar(require("@nexys/react-stateful"));
var MockData = __importStar(require("./mock-data"));
var EmailDataInterface = (function () {
    function EmailDataInterface(withBackend) {
        var _this = this;
        this.urlPrefix = '/superadmin';
        this.list = function () {
            if (!_this.withBackend) {
                return Promise.resolve(MockData.data);
            }
            return Stateful.Request.get(_this.urlPrefix + "/email/log/list");
        };
        this.detail = function (uuid) {
            if (!_this.withBackend) {
                var item = MockData.data.find(function (d) { return d.uuid === uuid; });
                return Promise.resolve(item || MockData.data[0]);
            }
            return Stateful.Request.post(_this.urlPrefix + "/email/log/detail", {
                uuid: uuid
            });
        };
        this.insert = function (data) {
            return Promise.resolve({ uuid: 'uuid1' });
        };
        this.update = function (data) { return Promise.resolve(true); };
        this.deleteById = function (id) { return Promise.resolve(true); };
        this.withBackend = Boolean(withBackend);
    }
    return EmailDataInterface;
}());
exports["default"] = EmailDataInterface;
exports.sendEmail = function (data, withBackend, urlPrefix) {
    if (urlPrefix === void 0) { urlPrefix = '/superadmin'; }
    if (!withBackend) {
        console.log('SEND EMAIL', data);
        return Promise.resolve(true);
    }
    return Stateful.Request.post(urlPrefix + "/email/send", data);
};
